<app-modal #modal></app-modal>
<h3>{{ title }}</h3>
<div *ngFor="let section of sections">
  <div *ngIf="section.xmlData">
    <div class="xml-accordion">
      <details class="p-2">
        <summary class="underline xmlModal" [title]="section.xmlData">
          {{ section.xmlTitle }}
        </summary>
      </details>
    </div>
  </div>
</div>
